// @flow

import * as React from 'react';
import { Link } from 'speed-js-react-web';
import GreyButton from 'esm-web-pro/components/layout/GreyButton';

type Props = {
    createRoute: string,
    match: Object,
    newObjectLabel: string,
}

const NewObjectButton = (props: Props) => {
    const { createRoute, match, newObjectLabel } = props;
    return (
        <Link to={createRoute || `${match.url}/new`.replace(/\/\//g, '/')}>
            {(p: Object) => (
                <GreyButton
                    plain={false}
                    alignSelf="center"
                    justify="evenly"
                    hoverIndicator="light-3"
                    style={{ display: 'flex', alignItems: 'center' }}
                    {...p}
                >
                    {newObjectLabel}
                </GreyButton>
            )}
        </Link>
    );
};

export default NewObjectButton;
